// Keep the exchange's fractional milliseconds as text: Date truncates them.
export function formatOrderTimestamp(value?: string | null, timestampMs?: string | null): string {
  if (!value && !timestampMs) return "—";
  const rawMs = timestampMs?.match(/^(\d+)(?:\.(\d+))?$/);
  const normalized = value && !/(Z|[+-]\d{2}:\d{2})$/i.test(value) ? `${value}Z` : value;
  const date = rawMs ? new Date(Number(rawMs[1])) : new Date(normalized || "");
  if (Number.isNaN(date.getTime())) return "—";
  const fraction = rawMs
    ? `${String(date.getMilliseconds()).padStart(3, "0")}${rawMs[2] || ""}`
    : value?.match(/\.(\d+)/)?.[1] || "000";
  return `${date.toLocaleString("ru-RU", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  })}.${fraction}`;
}
